import React from 'react';
import { Hero } from '../components/Hero';
import { WhyChoose } from '../components/WhyChoose';
import { ServiceCards } from '../components/ServiceCards';
import { ServiceAreas } from '../components/ServiceAreas';
import { Industries } from '../components/Industries';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { FaqSection } from '../components/FaqSection';
import { WorkGallery } from '../components/WorkGallery';
import { ContactSection } from '../components/ContactSection';
import { useLanguage } from '../contexts/LanguageContext';
import { usePageMeta } from '../hooks/usePageMeta';
import { ui } from '../data/ui';
import { buildPageSchema } from '../utils/schema';
export function Home() {
  const {
    t,
    lang
  } = useLanguage();
  usePageMeta({
    title: t(ui.meta.title),
    description: t(ui.meta.description),
    lang,
    schema: buildPageSchema(lang)
  });
  return <>
      <Hero data-id="element-388" data-mp="30wrpwio1y1gl" />
      <WhyChoose data-id="element-389" data-mp="30wjb2l8dcm2r" />
      <ServiceCards data-id="element-390" data-mp="30x1jeg8b2qr1" />
      <ServiceAreas data-id="element-391" data-mp="30vgjeb382fls" />
      <Industries data-id="element-392" data-mp="30up1u46gmiei" />
      <Process data-id="element-393" data-mp="2vxouzr1sdbmc" />
      <Testimonials data-id="element-394" data-mp="2vx6qk74yzr3c" />
      <FaqSection data-id="element-395" data-mp="2vyq77yujg45n" />
      <WorkGallery data-id="element-396" data-mp="2vy80u9e5w9k0" />
      <ContactSection data-id="element-397" data-mp="2vvlta9r9tu1s" />
    </>;
}